import {
  useState, useCallback, useEffect, useRef, useMemo,
} from 'react';
import { cond, prop, T } from 'ramda';

import i18n from '@/utils/i18n';
import { EN, DE, DEFAULT_LANGUAGE } from '@/utils/consts';
import { metrics } from '@/theme';

export const useContentByLang = (content) => useMemo(() => cond([
  [i18n.isEn, prop(EN)],
  [i18n.isDe, prop(DE)],
  [T, prop(DEFAULT_LANGUAGE)],
])(content), [content]);

export const useWidthApp = (onlyMobileDetect) => {
  const [width, setWidth] = useState(typeof window !== 'undefined' && window.innerWidth);
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' && window.innerWidth <= metrics.mobile);

  const handleResize = useCallback((e) => {
    setIsMobile(e.target.innerWidth <= metrics.mobile);

    if (onlyMobileDetect) return;

    setWidth(e.target.innerWidth);
  }, [onlyMobileDetect]);

  useEffect(() => {
    if (window) {
      window.addEventListener('resize', handleResize);
    }

    return () => {
      if (window) {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, [handleResize]);

  return { width, isMobile };
};

export const useMobileDetect = () => useWidthApp(true).isMobile;

export const useAsyncState = (init) => {
  const isMount = useRef();
  const [state, setState] = useState(init);

  const handleChange = useCallback((value) => {
    if (!isMount.current) return;

    setState(value);
  }, []);

  useEffect(() => {
    isMount.current = true;

    return () => {
      isMount.current = false;
    };
  }, []);

  return [state, handleChange, isMount];
};
